import React from "react";

const inputCls = "w-full bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50 transition-colors";
const labelCls = "text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5";

const KPI_CONFIG = [
  { key: "avgRating",    label: "Avg Rating",       color: "#00ff90" },
  { key: "atRisk",       label: "At Risk",           color: "#f87171" },
  { key: "reviewsDue30", label: "Reviews Due (30d)", color: "#fbbf24" },
  { key: "avgGoals",     label: "Avg Goals Done",    color: "#60a5fa" },
];

function generatePeriods() {
  const periods = [];
  const now = new Date();
  let year = now.getFullYear();
  let q    = Math.ceil((now.getMonth() + 1) / 3);
  for (let i = 0; i < 8; i++) {
    periods.push(`Q${q}-${year}`);
    q--;
    if (q === 0) { q = 4; year--; }
  }
  periods.push(`YTD-${now.getFullYear()}`);
  return periods;
}

export default function PerformanceFilters({ view, setView, filters, setFilters, kpis }) {
  const period    = filters?.period    ?? "";
  const ratingMin = filters?.ratingMin ?? "ALL";
  const status    = filters?.status    ?? "ALL";
  const search    = filters?.search    ?? "";

  const set = (k, v) => setFilters?.(f => ({ ...f, [k]: v }));
  const periods = generatePeriods();

  return (
    <div className="rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022] p-5 space-y-4">

      <div className="flex gap-2">
        {[
          { key: "team",  label: "Team Performance" },
          { key: "queue", label: "Review Queue"     },
        ].map(t => (
          <button key={t.key} onClick={() => setView?.(t.key)}
            className={`text-xs px-4 py-2 rounded-full border transition-colors ${
              view === t.key
                ? "bg-[#00ff90]/15 border-[#00ff90]/40 text-[#00ff90]"
                : "bg-transparent border-white/10 text-white/40 hover:border-[#00ff90]/20 hover:text-white/60"
            }`}>
            {t.label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
        <div>
          <label className={labelCls}>Period</label>
          <select className={inputCls} value={period} onChange={e => set("period", e.target.value)}>
            {periods.map(p => <option key={p} value={p}>{p}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>Min Rating</label>
          <select className={inputCls} value={ratingMin} onChange={e => set("ratingMin", e.target.value)}>
            <option value="ALL">All</option>
            <option value="3">≥ 3.0</option>
            <option value="4">≥ 4.0</option>
          </select>
        </div>
        <div>
          <label className={labelCls}>Status</label>
          <select className={inputCls} value={status} onChange={e => set("status", e.target.value)}>
            <option value="ALL">All</option>
            <option value="ON_TRACK">On Track</option>
            <option value="AT_RISK">At Risk</option>
          </select>
        </div>
        <div className="md:col-span-2">
          <label className={labelCls}>Search</label>
          <input className={inputCls} placeholder="Name or role…" value={search}
            onChange={e => set("search", e.target.value)} />
        </div>
      </div>

      {kpis && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 pt-1 border-t border-white/5">
          {KPI_CONFIG.map(({ key, label, color }) => (
            <div key={key} className="rounded-lg border border-white/5 bg-white/3 p-3 text-center">
              <p className="text-lg font-bold" style={{ color }}>{kpis[key] ?? "—"}</p>
              <p className="text-xs text-white/30 mt-0.5">{label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}